import { forwardRef } from 'react';
import type { HTMLAttributes } from 'react';
import { cx } from '../utils/cx.js';
import styles from './Skeleton.module.css';

export type SkeletonShape = 'block' | 'circle' | 'text';

export interface SkeletonProps extends HTMLAttributes<HTMLSpanElement> {
  shape?: SkeletonShape;
  /** CSS width/height, e.g. "40%", "120px", "3rem". Passed straight through
   *  to inline style since a placeholder's dimensions are inherently
   *  content-specific, not part of the token scale. */
  width?: string;
  height?: string;
}

export const Skeleton = forwardRef<HTMLSpanElement, SkeletonProps>(function Skeleton(
  { shape = 'block', width, height, className, style, 'aria-hidden': ariaHidden = true, ...rest },
  ref,
) {
  return (
    <span
      ref={ref}
      aria-hidden={ariaHidden}
      className={cx(styles.skeleton, shape !== 'block' && styles[shape], className)}
      style={{ width, height, ...style }}
      {...rest}
    />
  );
});
